export const isNaN = (x) => x !== x;
